import React from 'react';
import { observer } from 'mobx-react-lite';
import { Switch } from '@producer/ui-kit';

import styles from './sortable-property-item.module.scss';

interface PinnedPropertyItemProps {
  value: boolean;
  label: string;
  onToggle: (value: boolean) => void;
}

export const PinnedPropertyItem: React.FC<PinnedPropertyItemProps> = observer(
  ({ label, value, onToggle }) => {
    return (
      <div className={styles.item}>
        <p className={styles.name}>{label}</p>

        <div className={styles.actions}>
          <Switch size="medium" isToggled={value} onToggle={(value) => onToggle(value)} />
        </div>
      </div>
    );
  },
);
